import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * BMSFaultChart - Styled component that conditionally applies cursor pointer
 * styling when drill-down functionality is available
 * 
 * @param {boolean} drillDownEnabled - Whether drill-down is enabled for the chart
 */
const BMSFaultChart = styled(Box)(({ drillDownEnabled }) => ({
  width: '100%',
  height: '100%',
  ...(drillDownEnabled && {
    '& .apexcharts-bar-area': {
      cursor: 'pointer',
    },
    '& .apexcharts-marker': {
      cursor: 'pointer',
    },
    '& .apexcharts-data-labels': {
      cursor: 'pointer',
    },
    '& .apexcharts-column-series .apexcharts-bar-area': {
      cursor: 'pointer',
    },
    '& .apexcharts-line-series .apexcharts-marker': {
      cursor: 'pointer',
    },
  }),
}));

export default BMSFaultChart;
